import React, { useState, useEffect, useRef } from "react";
import WorkflowDesign from "./WorkflowDesign";

const WorkflowMapPopup = ({ selectedObj: propSelectedObj, workflowShowHide, handleWorkflowModalShowHide }) => {
  const [selectedObj, setSelectedObj] = useState({});
  const myRef = useRef(null);

  useEffect(() => {
    setSelectedObj(propSelectedObj);
  }, [propSelectedObj]);

  if (!workflowShowHide) return null;

  return (
    <div>
      <div className="row">
        <div className="col">
          <h4>
            Process ID - <span>{selectedObj?.ciid}</span>, Task Name -{" "}
            <span>{selectedObj?.itemName}</span>
          </h4>
        </div>
        <div>
          <button
            className="btn btn-outline-default btn-sm"
            onClick={() => handleWorkflowModalShowHide("")}
          >
            <i className="fa fa-times mr-2" aria-hidden="true"></i>Close
          </button>
        </div>
      </div>
      <div className="row ml-1">
       {selectedObj?.ciid &&  <WorkflowDesign selectedObj={selectedObj} />}
        <div ref={myRef} />
      </div>
    </div>
  );
};

export default WorkflowMapPopup;
